import { type TeamData } from '@/components/molecules/Team'
import { type Team } from '@/model/contexts/TeamsProvider.tsx'

type TeamCar = TeamData['car']

export const teamCarType = (vehicle: Team['vehicle']): TeamCar['carType'] => {
  switch (true) {
    case vehicle.electric:
      return 'electric'
    case vehicle.manual:
      return 'manual'
    default:
      return 'automatic'
  }
}

const teamState = (status: Team['status']): TeamCar['state'] => {
  switch (status) {
    case 'ASSIGNED':
      return 'assigned'
    case 'AVAILABLE_IN_LOCATION':
    case 'AVAILABLE_IN_INSTITUTION':
    case 'AVAILABLE_IN_REGION':
    case 'AVAILABLE_AT_COORDINATES':
      return 'available'
    case 'ON_BREAK':
      return 'onHold'
    case 'DISSOLVED':
    case 'IN_RETURN':
      return 'inReturn'
    default:
      return 'inReturn'
  }
}
export const teamCar = (team: Team): TeamCar => ({
  carNumber: team.number ?? '?',
  state: teamState(team.status),
  carType: teamCarType(team.vehicle),
})
